<template>
  <div class="careteam">
    <CareTeamModal
      @showProfile="showProfile()"
      @kick="kick()"
      @close="closeCareTeamModal()"
      :isShow="showCareTeamModal"
      :careteam="selectedCareTeam"
    />

    <Modal
      v-model="modal1"
      title="Add Care Team"
      class-name="tel-input-modal"
      :footer-hide="true"
      @on-cancel="cancel"
    >
      <!-- <h1 align="center">Coming Soon</h1> -->
      <div>
        <Tabs v-model="inviteVia" class="careteam-tabs" :animated="false">
            <TabPane name="mobile" label="Mobile Number"/>
            <TabPane name="email" label="Email"/>
        </Tabs>
        <div style="margin-top: 10px; padding: 6px;">
          <div v-if="inviteVia == 'mobile'">
            <tel-input-lg v-model="mobileNumber" @onTelInput="onTelInput" ref="telInput" />
          </div>
          <div v-else>
            <Input type="email" v-model="contactEmail" @on-change="onInput" placeholder="Enter your email" />
          </div>
        </div>
        <br />
        <p align="right">
          <Button type="primary" :loading="isLoading" :disabled="inviteDisabled" @click="inviteTeamMember(mobileNumber, contactEmail)">Invite</Button>
        </p>
      </div>
    </Modal>

    <!-- <Row :gutter="10" style="padding:5px 10px 0">
            <i-col :span="19" style="padding:3px">
                <Input placeholder="search" v-model="searchTeam">
                    <template slot="append">
                        <Button size='small' @click="getCareTeam(searchTeam)">Search</Button>
                    </template>
                </Input>
            </i-col>
            <i-col :span="5">
                <p style="padding:5px">
                    <Button long size="small" type="primary" @click="modal1 = true">Invite</Button>
                </p>
            </i-col>
    </Row>-->
    <Row>
      <i-col v-show="!isLoadingCareteamlist" :span="24">
        <span
          v-for="(n, k) in careteamlistItems"
          class="pointer"
          :key="k"
          @click="openCareTeamModal(n)"
        >
          <Avatar class="careteam-member" :src="userDisplayImage(n)"></Avatar>
        </span>
        <span v-if="!hideControl" class="pointer" @click="modal1 = true" v-show="isCurrentUser">
          <Avatar style="margin-right:10px" icon="plus"></Avatar>
        </span>
      </i-col>
      <i-col v-show="isLoadingCareteamlist">
        <p align="left" style="margin-top:5px">
          <i class="fa fa-spin fa-spinner" />&nbsp; Loading...
        </p>
      </i-col>
    </Row>
    <!-- <p align="center" style="margin-top:5px" v-show="careteamlistItems && careteamlistItems.length <= 0 && !isLoadingCareteamlist">
            <span style="color:#aaa">No members found</span>
    </p>-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Message } from "iview";
import Utils from "@/utils.js";
import CareTeamModal from "@/components/CareteamModal";
import { TelInputLg } from "@/helpers/tel-input";
import _ from "lodash";

export default {
  components: {
    CareTeamModal,
    TelInputLg
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    isCurrentUser: {
      type: Boolean,
      required: true
    },
    hideControl: {
      type: Boolean,
      required: false
    }
  },
  mounted() {
    this.getCareTeam();
    this.getBrandUsers();
  },
  data() {
    return {
      modal1: false,
      searchTeam: null,
      searchUser: null,
      userList: {},
      selectedCareTeam: {},
      showCareTeamModal: false,
      mobileNumber: null,
      contactEmail: null,
      isLoading: false,
      invalidMobile: true,
      invalidEmail: true,
      careteamlistItems: [],
      inviteVia: "email"
    };
  },
  computed: {
    ...mapGetters("user", [
      "userInfo",
      "brandInfo",
      "careteamlist",
      "isLoadingCareteamlist",
      "isLoadingAddCareteam",
      "isLoadingBrandUsers",
      "isLoadingKickCareteam"
    ]),
    ...mapGetters("publicProfile", [
      "publicUserInfo"
    ]),
    inviteDisabled() {
      if (this.inviteVia == "email") {
        return this.invalidEmail
      }
      else {
        return this.invalidMobile
      }
    },
    userListItems() {
      return this.userList.subscribers;
    },
    // careteamlistItems() {
    //   let res = this.careteamlist.subscribers;

    //   var index = _.findIndex(res, o => {
    //     return o.id == this.userInfo.id;
    //   });

    //   if (index > -1) {
    //     res.splice(index, 1);
    //   }

    //   return res;
    // }
  },
  watch: {
    $route: function(n, o) {
      if (n) {
        this.getCareTeam();
        this.getBrandUsers();
      }
    }
  },
  methods: {
    onTelInput(res) {
      this.invalidMobile = res.isValid == false;
      this.mobileNumber = res.isValid ? res.number : null;
    },
    onInput(res){
      this.invalidEmail = this.validateEmail(this.contactEmail) == false;
      this.contactEmail = this.invalid ? null: this.contactEmail;
    },
    kick() {
      this.kickCareteam(this.selectedCareTeam);
      this.closeCareTeamModal();
    },
    showProfile() {
      this.$emit("showProfile");
      if (this.selectedCareTeam.user_type == "member")
        this.$router.push("/profile/" + this.selectedCareTeam.id);
      else
        this.$router.push("/organization/" + this.selectedCareTeam.careplan_id);

      this.closeCareTeamModal();
    },
    closeCareTeamModal() {
      this.showCareTeamModal = false;
    },
    openCareTeamModal(v) {
      if (!this.isCurrentUser) return;
      this.selectedCareTeam = v;
      if (this.hideControl) {
        this.showProfile();
        return;
      }
      this.showCareTeamModal = true;
    },
    cancel() {
      this.modal1 = false;
      this.$refs.telInput.resetNum();
      this.contactEmail = '';
      this.invalidMobile = true;
      this.invalidEmail = true;
      this.getCareTeam();
    },
    userDisplayImage(user) {
      return Utils.getDisplayImage("user", user, "small");
    },
    showErrorModal(title, content, callback) {
      this.$Message({
        closable: true,
        title: { content: title },
        icon: "alert",
        message: { content: content },
        buttons: [
          {
            label: "Ok",
            type: "primary",
            hideAfter: true,
            action: () => callback
          }
        ]
      });
    },
    showMessage(content) {
      Message.warning(content);
    },
    validate() {
      if (this.contactEmail && !this.validateEmail(this.contactEmail)) {
        this.showMessage("Invalid email format");
        this.isLoading = false;
        return false;
      }
      return true;
    },
    validateEmail(email) {
      return Utils.validateEmail(email);
    },
    inviteTeamMember(num, email) {
      let data = {
        careplan_id: this.user.private_careplan_id,
        brand_id: this.brandInfo.id,
        doctor_id: this.brandInfo.id,
        // journal_id: user.pivot.journal_id,
        mobile: num,
        email: email
      };

      this.isLoading = true;
      if (!this.validate()) return;
      this.addCareteam(data);
    },
    async addCareteam(data) {
      try {
        let res = await this.$store.dispatch("user/addCareteam", data);

        this.$Message({
          closable: true,
          durationInSec: 3,
          title: { content: "Success" },
          message: { content: "Invitation Sent" }
        });
        this.cancel();
      } catch (error) {
        this.$Message({
          closable: true,
          durationInSec: 3,
          title: { content: "Error" },
          message: {
            content: error.response.data.error.message.includes(
              "already a member"
            )
              ? "User is already a member of your care team"
              : "Unable to send invitation"
          }
        });
      } finally {
        this.isLoading = false;
      }
    },
    async getCareTeam(k) {
      try {
        let res = await this.$store.dispatch("user/getCareteam", {
          id: this.isCurrentUser ? this.userInfo.private_careplan_id : this.publicUserInfo.private_careplan_id,
          key: k
        });
        let data = res.subscribers
        var index = _.findIndex(data, o => {
          return o.id == this.user.id;
        });

        if (index > -1) {
          data.splice(index, 1);
        }

        this.careteamlistItems = data
      } catch (error) {
        console.log(error);
      }
    },
    async getBrandUsers(k) {
      try {
        let res = await this.$store.dispatch("user/getBrandUsers", {
          id: this.user.private_careplan_id,
          key: k
        });
        this.userList = res;
      } catch (error) {
        console.log(error);
      }
    },
    kickCareteam(user) {
      this.$Message({
        closable: true,
        title: { content: "Remove User" },
        icon: "ios-trash",
        message: { content: "Are you sure you want to remove this user?" },
        buttons: [
          {
            label: "Yes",
            type: "error",
            hideAfter: true,
            action: async () => {
              try {
                let res = await this.$store.dispatch(
                  "user/kickCareteam",
                  user.pivot.id
                );

                let find = this.careteamlistItems.findIndex(
                  m => m.pivot.id === user.pivot.id
                );

                if (find >= 0) {
                  this.careteamlistItems.splice(find, 1);
                  this.$Message({
                    closable: true,
                    durationInSec: 3,
                    title: { content: "Success" },
                    message: { content: "User removed." }
                  });
                }
              } catch (error) {}
            }
          },
          {
            label: "Cancel",
            type: "primary",
            hideAfter: true,
            action: () => {}
          }
        ]
      });
    }
  }
};
</script>

<style lang="scss">
.tel-input-modal .ivu-modal-body {
  overflow: visible;
}
.careteam-member {
  margin-right: 10px;
  img {
    object-fit: cover;
  }
}
.careteam-tabs .ivu-tabs-nav .ivu-tabs-tab-active {
  background: #f0f0f0 !important;
}
</style>
